import axios from 'axios';
import { queryCache, useMutation } from 'react-query';

const updateSentence = ({ id, payload }) => {
  return axios.put(`/api/v3/sentences/${id}`, payload);
};

export const useMutateSentence = (itemId: string = '', setId: string = '') => {
  return useMutation(updateSentence, {
    onError: (error: any) => {
      console.error(`ERROR! ${error}`);
    },
    onSettled: () => {
      queryCache.invalidateQueries(`item-${itemId}`);
      queryCache.invalidateQueries(['assignmentItems', setId]);
    },
  });
};
